import { render, staticRenderFns } from "./BaseH1.vue?vue&type=template&id=8a704fb0&"
import script from "./BaseH1.vue?vue&type=script&lang=js&"
export * from "./BaseH1.vue?vue&type=script&lang=js&"
import style0 from "./BaseH1.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports